/** Conversation ownership / escalation case state for the admin inbox. */
export const ARIA_HANDOFF_STATUS = {
  HANDOFF_REQUESTED: 'handoff_requested',
  ADMIN_ACTIVE: 'admin_active',
  RESOLVED: 'resolved',
  ARIA_ACTIVE: 'aria_active',
};

export const ARIA_HANDOFF_STATUS_META = {
  [ARIA_HANDOFF_STATUS.ARIA_ACTIVE]: {
    label: 'Aria holding',
    color: '#2563eb',
    bgcolor: '#eff6ff',
  },
  [ARIA_HANDOFF_STATUS.HANDOFF_REQUESTED]: {
    label: 'Needs person',
    color: '#b45309',
    bgcolor: 'primary.light',
  },
  [ARIA_HANDOFF_STATUS.ADMIN_ACTIVE]: {
    label: 'Admin active',
    color: '#047857',
    bgcolor: '#ecfdf5',
  },
  [ARIA_HANDOFF_STATUS.RESOLVED]: {
    label: 'Resolved',
    color: 'text.secondary',
    bgcolor: 'action.hover',
  },
};

/** API escalation status values for GET /aria/escalations?status= */
export const ARIA_ESCALATION_API_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
};

/** Status filter tabs above the escalation chat list. */
export const ARIA_ESCALATION_STATUS_TABS = [
  { value: ARIA_ESCALATION_API_STATUS.OPEN, label: 'Open' },
  { value: ARIA_ESCALATION_API_STATUS.IN_PROGRESS, label: 'In progress' },
  { value: ARIA_ESCALATION_API_STATUS.RESOLVED, label: 'Resolved' },
];

export const ARIA_ESCALATION_STATUS_TAB_MAP = ARIA_ESCALATION_STATUS_TABS.reduce((acc, tab) => {
  acc[tab.value] = tab;
  return acc;
}, {});

export const DEFAULT_ARIA_ESCALATION_STATUS = ARIA_ESCALATION_API_STATUS.OPEN;

export const ARIA_ESCALATIONS_PAGE_SIZE = 20;

export const ARIA_ALL_QUEUE = 'all';

/** Partner inbox only surfaces these three queues. */
export const PARTNER_ARIA_ESCALATION_QUEUE_VALUES = [
  'human_requested',
  'complaint_conflict',
  'event_complaint',
];

const ARIA_ALL_QUEUE_NAV_ITEM = {
  value: ARIA_ALL_QUEUE,
  label: 'All',
  shortLabel: 'ALL',
  color: 'text.secondary',
  bgcolor: 'action.hover',
};

/** Escalation queues — same labels as Ops Inbox reference. */
export const ARIA_ESCALATION_QUEUES = [
  {
    value: 'human_requested',
    label: 'Human requested',
    shortLabel: 'HUMAN REQ',
    color: '#9f1239',
    bgcolor: '#ffe4e6',
  },
  {
    value: 'safety_trust',
    label: 'Safety & trust',
    shortLabel: 'SAFETY',
    color: '#9a3412',
    bgcolor: '#ffedd5',
  },
  {
    value: 'complaint_conflict',
    label: 'Complaint / conflict',
    shortLabel: 'COMPLAINT',
    color: '#7c2d12',
    bgcolor: '#fed7aa',
  },
  {
    value: 'billing_membership',
    label: 'Billing & membership',
    shortLabel: 'BILLING',
    color: '#1e40af',
    bgcolor: '#dbeafe',
  },
  {
    value: 'match_dispute',
    label: 'Match dispute',
    shortLabel: 'MATCH',
    color: '#6b21a8',
    bgcolor: '#f3e8ff',
  },
  {
    value: 'technical_support',
    label: 'Technical support',
    shortLabel: 'TECH',
    color: '#155e75',
    bgcolor: '#cffafe',
  },
  {
    value: 'event_complaint',
    label: 'Event complaint',
    shortLabel: 'EVENT',
    color: '#9f1239',
    bgcolor: '#fecdd3',
  },
];

export const PARTNER_ARIA_ESCALATION_QUEUES = ARIA_ESCALATION_QUEUES.filter((queue) =>
  PARTNER_ARIA_ESCALATION_QUEUE_VALUES.includes(queue.value),
);

export const buildAriaQueueNavItems = (queues = ARIA_ESCALATION_QUEUES) => [
  ARIA_ALL_QUEUE_NAV_ITEM,
  ...queues,
];

/** Left-rail tabs including All (omits `queue` query param). */
export const ARIA_QUEUE_NAV_ITEMS = buildAriaQueueNavItems(ARIA_ESCALATION_QUEUES);

export const PARTNER_ARIA_QUEUE_NAV_ITEMS = buildAriaQueueNavItems(PARTNER_ARIA_ESCALATION_QUEUES);

export const getAriaQueueNavItems = (isPartner) =>
  isPartner ? PARTNER_ARIA_QUEUE_NAV_ITEMS : ARIA_QUEUE_NAV_ITEMS;

export const ARIA_ESCALATION_QUEUE_MAP = ARIA_QUEUE_NAV_ITEMS.reduce((acc, queue) => {
  acc[queue.value] = queue;
  return acc;
}, {});

export const DEFAULT_ARIA_ESCALATION_QUEUE = ARIA_ALL_QUEUE;

export const ARIA_BOT_NAME = 'Aria';
export const ARIA_BOT_AVATAR =
  'https://api.dicebear.com/7.x/bottts/svg?seed=Aria&backgroundColor=fff7ed';
